var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c(_vm.tag,_vm._b({tag:"component",staticClass:"nav-link",nativeOn:{"click":function($event){return _vm.hideSidebar.apply(null, arguments)}}},'component',_vm.$attrs,false),[_vm._t("default",function(){return [(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.name))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }